export default [
    {
        path: '/interveners',
        name: 'interveners',
        component: () => import('@/views/interveners-list/index.vue')
    },
    {
        path      : '/interveners/add',
        name      : 'interveners_add',
        component : () => import('@/views/interveners-details/index.vue')
    },
    {
        path: '/interveners/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: 'view',
                name: 'interveners_uuid',
                component: () => import('@/views/interveners-details/index.vue')
            },
            {
                path: 'related-interveners-view',
                name: 'related_interveners_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            },
            {
                path: 'intervener-participant-accounts-uuid-view',
                name: 'intervener_participant_accounts_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            },
            {
                path: 'intervener-documentation-uuid-view',
                name: 'intervener_documentation_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            },
            {
                path      : 'interveners-uuid-view',
                name      : 'interveners_uuid_view',
                component : () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta      : {
                    isView: true
                }
            }
            // {
            //     path      : 'edit',
            //     name      : 'interveners_uuid_edit',
            //     component : () => import('@/views/interveners-details/index.vue')
            // },
        ]
    }
];
